<div class="mb-8">
  <app-form-title-with-subtitle>
    <span title>Aktywacja konta użytkownika</span>
  </app-form-title-with-subtitle>

  <div class="flex justify-center">
    @if (isAlertVisible()) {
      <app-alerts />
    } @else {
      <app-spinner />
    }
  </div>
</div>

<div class="mb-8 text-center">
  <p-button
    (onClick)="handleNavigateToSignInPageClick()"
    appPrimengButton
    label="Przejdź do strony logowania" />
</div>
